import { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const openDrawer = () => setIsOpenDrawer(true);
  const closeDrawer = () => setIsOpenDrawer(false);
  const toggleDrawer = () => setIsOpenDrawer((prev) => !prev);

  return (
    <GlobalContext.Provider value={{ isOpenDrawer, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);